import Link from "next/link";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

// replace (not append) the radius: bricostore prev/next are pills, altex/MG keep rounded-md
const pageRadius = isBricoStore ? "rounded-full" : "rounded-md";

const DirectionalButtonWrapper = ({ url, children }) => {
  if (url) {
    return (
      <Link href={url}>
        <a className={`inline-block py-1 px-2 mx-0.5 sm:mx-1 text-sm border border-gray-1100 ${pageRadius} items-center text-center bg-white`}>
          {children}
        </a>
      </Link>
    );
  }

  return (
    <div className={`text-gray inline-block py-1 px-2 mx-0.5 sm:mx-1 text-sm border border-gray-1100 ${pageRadius} items-center text-center bg-white`}>
      {children}
    </div>
  );
};

export default DirectionalButtonWrapper;
